import { render, staticRenderFns } from "./MetaCompany.vue?vue&type=template&id=3e10f3a6&scoped=true&"
import script from "./MetaCompany.vue?vue&type=script&lang=ts&"
export * from "./MetaCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e10f3a6",
  null
  
)

export default component.exports